const ShowHideArrowIcon = ({ color }: { color?: string }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.60001 8.00039L12.875 2.65039C13.1 2.42539 13.1 2.07539 12.875 1.85039C12.65 1.62539 12.3 1.62539 12.075 1.85039L6.42501 7.60039C6.20001 7.82539 6.20001 8.17539 6.42501 8.40039L12.075 14.1504C12.175 14.2504 12.325 14.3254 12.475 14.3254C12.625 14.3254 12.75 14.2754 12.875 14.1754C13.1 13.9504 13.1 13.6004 12.875 13.3754L7.60001 8.00039Z"
        fill={color ?? "#9CA3AF"}
      />
      <path
        d="M4.35001 8.00039L9.62501 2.65039C9.85001 2.42539 9.85001 2.07539 9.62501 1.85039C9.40001 1.62539 9.05001 1.62539 8.82501 1.85039L3.17501 7.60039C2.95001 7.82539 2.95001 8.17539 3.17501 8.40039L8.82501 14.1504C8.92501 14.2504 9.07501 14.3254 9.22501 14.3254C9.37501 14.3254 9.50001 14.2754 9.62501 14.1754C9.85001 13.9504 9.85001 13.6004 9.62501 13.3754L4.35001 8.00039Z"
        fill={color ?? "#9CA3AF"}
      />
    </svg>
  );
};

export default ShowHideArrowIcon;
